<template>
    <vx-server-side-table
        v-model="selected"
        v-on="listeners"
        ref="lineTable"
        class="practices-table"
        :fetch-data="$api.admin.practice.fetch"
        :columns="columns"
        enable-search
        paginate
    ></vx-server-side-table>
</template>

<script>
import PracticeLineDetail from './PracticeLineDetail.vue'
import mixin from '../../crm/apps/tableMixin'
import UserAvatar from '../../../components/project/UserProfiles/UserAvatar.vue'

export default {
    name: 'practices-table',
    mixins: [mixin],
    components: { PracticeLineDetail, UserAvatar },
    data() {
        return {}
    },
    computed: {
        columns() {
            return [
                {
                    title: 'ID',
                    value: 'id',
                    visible: this.userHasRole(['SuperUser']),
                    sort: 'id'
                },
                {
                    title: 'Name',
                    value: 'name',
                    sort: 'name'
                },
                {
                    title: 'Address',
                    value: (row) =>
                        row.address
                            ? row.address.streetAddress1 +
                              ', ' +
                              row.address.suburb +
                              ', ' +
                              row.address.state +
                              ', ' +
                              row.address.postcode
                            : 'NA',
                    visible: !this.detailsOpen
                    //format:  //+ ', ' + row.Suburb + ', ' + row.State
                },
                {
                    title: 'State',
                    value: (row) => (row.address ? row.address.state : ''),
                    sort: 'address.state'
                },
                {
                    title: 'Postcode',
                    value: (row) => (row.address ? row.address.postcode : ''),
                    sort: 'address.postcode'
                },
                {
                    title: 'Phone',
                    value: 'phone',
                    sort: 'phone'
                },
                {
                    title: 'Fax',
                    value: 'fax',
                    sort: 'fax'
                },
                {
                    title: 'Email Address',
                    value: 'emailAddress',
                    sort: 'emailAddress'
                }
            ]
        }
    },
    mounted() {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';
.line-detail-pane {
    border-left: 2px solid rgba(var(--vs-primary), 1);
}

.line-detail-pointer {
    width: 25px;
    height: 25px;
    transform: rotate(45deg);
    position: absolute;
    left: 2px;
    background-color: rgba(var(--vs-primary), 1);
    transition: all 0.35s ease;
}

div.disable-events {
    pointer-events: none;
}
</style>
